"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Copy;

var _Copy = require("@adobe/react-spectrum-workflow/dist/Copy");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Copy(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Copy.A4uCopy, null));
}